function sectorTypes(t) {
  return [
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.ALUMINIUM"
      ),
      value: "ALUMINIUM",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.MALL_SUPER_MARKET"
      ),
      value: "MALL_SUPER_MARKET",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.BANKING_FINANCE"
      ),
      value: "BANKING_FINANCE",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.EDUCATION"
      ),
      value: "EDUCATION",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.ELECTRICAL_ELECTRONIC"
      ),
      value: "ELECTRICAL_ELECTRONIC",
    },
    {
      name: t("pages.default.redemption.options.beneficiary.sectortype.ENERGY"),
      value: "ENERGY",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.FOOD_INDUSTRY"
      ),
      value: "FOOD_INDUSTRY",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.CONSTRUCTION"
      ),
      value: "CONSTRUCTION",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.COSMETIC"
      ),
      value: "COSMETIC",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.MACHINE_CHEMISTRY_OIL"
      ),
      value: "MACHINE_CHEMISTRY_OIL",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.RESIDENTIAL"
      ),
      value: "RESIDENTIAL",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.METAL_MINING"
      ),
      value: "METAL_MINING",
    },
    {
      name: t("pages.default.redemption.options.beneficiary.sectortype.OFFICE"),
      value: "OFFICE",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.AUTOMOTIVE"
      ),
      value: "AUTOMOTIVE",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.HEALTH_SOCIAL_SERVICES"
      ),
      value: "HEALTH_SOCIAL_SERVICES",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.INDUSTRY"
      ),
      value: "INDUSTRY",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.AGRICULTURE_LIVESTOCK"
      ),
      value: "AGRICULTURE_LIVESTOCK",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.TECHNOLOGY_WHITE_GOODS"
      ),
      value: "TECHNOLOGY_WHITE_GOODS",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.TEXTILE"
      ),
      value: "TEXTILE",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.TELECOMMUNICATION"
      ),
      value: "TELECOMMUNICATION",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.TOURISM_HOTEL_MANAGEMENT"
      ),
      value: "TOURISM_HOTEL_MANAGEMENT",
    },
    {
      name: t(
        "pages.default.redemption.options.beneficiary.sectortype.TRANSPORTATION_LOGISTICS"
      ),
      value: "TRANSPORTATION_LOGISTICS",
    },
    {
      name: t("pages.default.redemption.options.beneficiary.sectortype.OTHER"),
      value: "OTHER",
    },
  ];
}

function resourceTypes(t) {
  return [
    {
      name: t("pages.default.certificates.filters.allResourceTypes"),
      value: "-",
    },
    { name: t("ui.default.codes.BIOMASS"), value: "BIOMASS" },
    { name: t("ui.default.codes.WIND"), value: "WIND" },
    { name: t("ui.default.codes.HYDROPOWER"), value: "HYDROPOWER" },
    { name: t("ui.default.codes.GEOTHERMAL"), value: "GEOTHERMAL" },
    { name: t("ui.default.codes.SOLAR"), value: "SOLAR" },
  ];
}
function contractTypes(t) {
  return [
    {
      name: t("ui.default.codes.ALLCONTRACTS"),
      value: "-",
    },
    { name: t("ui.default.codes.BIOMASS"), value: "BIOMASS" },
    { name: t("ui.default.codes.WIND"), value: "WIND" },
    { name: t("ui.default.codes.HYDROPOWER"), value: "HYDROPOWER" },
    { name: t("ui.default.codes.GEOTHERMAL"), value: "GEOTHERMAL" },
    { name: t("ui.default.codes.SOLAR"), value: "SOLAR" },
  ];
}
function redemptionPurpose(t) {
  return [
    { name: "", value: "-", disabled: true },
    {
      value: "IFSA_YESIL_TARIFE",
      name: t("pages.default.redemption.options.IFSA_YESIL_TARIFE"),
    },
    {
      value: "IFSA",
      name: t("pages.default.redemption.options.IFSA"),
    },
  ];
}
function beneficiaryTypes(t) {
  return [
    { name: "", value: "-", disabled: true },
    { name: t("pages.default.redemption.options.consumer"), value: "CONSUMER" },
    { name: t("pages.default.redemption.options.producer"), value: "PRODUCER" },
    {
      name: t("pages.default.redemption.options.k1_producer"),
      value: "K1_PRODUCER",
    },
  ];
}
function certificateStatuses(t) {
  return [
    {
      name: t("pages.default.certificates.filters.allStatus"),
      value: ["ACTIVE", "BLOCK"],
    },
    {
      name: t("ui.default.codes.ACTIVE"),
      value: "ACTIVE",
    },
    {
      name: t("ui.default.codes.BLOCK"),
      value: "BLOCK",
    },
  ];
}

function plantStatuses(t) {
  return [
    {
      name: t("ui.default.codes.ALLSTATUS"),
      value: "",
    },
    {
      name: t("ui.default.codes.ACTIVE"),
      value: true,
    },
    {
      name: t("ui.default.codes.PASSIVE"),
      value: false,
    },
  ];
}
function participationListPlantStatuses(t) {
  return [
    {
      name: t("ui.default.codes.ALLSTATUS"),
      value: "",
    },
    {
      name: t("ui.default.codes.ACTIVE"),
      value: "ACTIVE",
    },
    {
      name: t("ui.default.codes.PASSIVE"),
      value: "PASSIVE",
    },
    {
      name: t("ui.default.codes.PARTIAL_PASSIVE"),
      value: "PARTIAL_PASSIVE",
    },
  ];
}

function operationTypes(t) {
  return [
    {
      name: t("pages.default.operationHistory.filters.allOperationTypes"),
      value: "",
    },
    {
      name: t("pages.default.operationHistory.filters.user"),
      value: "USER",
    },
    {
      name: t("pages.default.operationHistory.filters.system"),
      value: "SYSTEM",
    },
  ];
}

function subjects(t) {
  return [
    {
      name: t("pages.default.operationHistory.filters.allSubjects"),
      value: "",
    },
    {
      name: t("pages.default.operationHistory.filters.export"),
      value: "EXPORT",
    },
    {
      name: t("pages.default.operationHistory.filters.bilateralAgreement"),
      value: "BILATERAL_AGREEMENT",
    },
    {
      name: t("pages.default.operationHistory.filters.redemption"),
      value: "REDEMPTION",
    },
    {
      name: t("pages.default.operationHistory.filters.registry"),
      value: "REGISTRY",
    },
    {
      name: t("pages.default.operationHistory.filters.guarantee"),
      value: "GUARANTEE",
    },
    {
      name: t("pages.default.operationHistory.filters.exchange"),
      value: "EXCHANGE",
    },
    {
      name: t("pages.default.operationHistory.filters.userMoves"),
      value: "USER_MOVES",
    },
    {
      name: t("pages.default.operationHistory.filters.systemParameter"),
      value: "SYSTEM_PARAMETER",
    },
    {
      name: t("pages.default.operationHistory.filters.bid"),
      value: "BID",
    },
    {
      name: t("pages.default.operationHistory.filters.objection"),
      value: "OBJECTION",
    },
    {
      name: t("pages.default.operationHistory.filters.match"),
      value: "MATCH",
    },
    {
      name: t("pages.default.operationHistory.filters.cancel"),
      value: "CANCEL",
    },
    {
      name: t("pages.default.operationHistory.filters.repeal"),
      value: "REPEAL",
    },
    {
      name: t("pages.default.operationHistory.filters.errorMessage"),
      value: "ERROR_MESSAGE",
    },
    {
      name: t("pages.default.operationHistory.filters.processChanges"),
      value: "PROCESS_CHANGES",
    },
    {
      name: t("pages.default.operationHistory.filters.processCreate"),
      value: "PROCESS_CREATE",
    },
    {
      name: t("pages.default.operationHistory.filters.contract"),
      value: "CONTRACT",
    },
    {
      name: t("pages.default.operationHistory.filters.GDDK"),
      value: "GDDK",
    },
    {
      name: t("pages.default.operationHistory.filters.reconciliation"),
      value: "RECONCILIATION",
    },
    {
      name: t("pages.default.operationHistory.filters.limitOperation"),
      value: "LIMIT_OPERATION",
    },
    {
      name: t("pages.default.operationHistory.filters.takasBank"),
      value: "TAKASBANK",
    },
  ];
}

function importance(t) {
  return [
    {
      name: t("pages.default.operationHistory.filters.allImportances"),
      value: "",
    },
    {
      name: t("pages.default.operationHistory.filters.info"),
      value: "INFO",
    },
  ];
}

export {
  resourceTypes,
  redemptionPurpose,
  beneficiaryTypes,
  certificateStatuses,
  operationTypes,
  subjects,
  importance,
  contractTypes,
  sectorTypes,
  plantStatuses,
  participationListPlantStatuses,
};
